"use strict";
export var PopupType = /* @__PURE__ */ ((PopupType2) => {
  PopupType2["Transaction"] = "transaction";
  PopupType2["Order"] = "order";
  PopupType2["FailedSwitchNetwork"] = "failedSwitchNetwork";
  PopupType2["SwitchNetwork"] = "switchNetwork";
  PopupType2["Bridge"] = "bridge";
  PopupType2["Mismatch"] = "mismatch";
  PopupType2["FORTransaction"] = "forTransaction";
  return PopupType2;
})(PopupType || {});
